<template>
  <div class="card-box">
    <div class="title" :class="[long ? 'long' : 'short']">
        {{title}}
    </div>
    <img src="https://files.wondercv.com/m/ai/dot.png" alt="" v-for="item in 4" :key="item" :class="['dot','dot'+item]">
    <slot/>
  </div>
</template>

<script>
  export default {
    name: "Card",
    props:{
      title:{
        type: String,
        default: ""
      },
      long: Boolean
    }
  }
</script>

<style scoped lang="scss">
  .card-box{
    width: 347px;
    background: #250A66;
    box-shadow: 0px 0px 12px 0px #582EBC inset;
    border-radius: 10px;
    border: 1px solid #4E26B1;
    position: relative;
    z-index: 2;
    margin: 0 auto 32px;
    padding: 35px 0px 30px;
    .title{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -12px;
      height: 41px;
      text-align: center;
      line-height: 41px;
      color:#fff;
      font-size: 16px;
      font-weight: 500;
    }
    .long{
      width: 210px;
      background-image: url("https://files.wondercv.com/m/ai/title-long.png");
      background-size: 100%;
    }
    .short{
      width: 190px;
      background-image: url("https://files.wondercv.com/m/ai/titile-short.png");
      background-size: 100%;
    }
    .dot{
      width: 20px;
      height: 20px;
      position: absolute;
    }
    .dot1{
      top: 10px;
      left: 10px;
    }
    .dot2{
      top: 10px;
      right: 10px;
      transform: rotate(90deg);
    }
    .dot3{
      left:10px;
      bottom: 10px;
      transform: rotate(270deg);
    }
    .dot4{
      right: 10px;
      bottom: 10px;
      transform: rotate(180deg);
    }
  }
</style>